var map = {
	"./p1.jpg": 2231,
	"./p2.jpg": 4601,
	"./p3.jpg": 9465,
	"./p4.jpg": 1890,
	"./p5.jpg": 3448,
	"./p6.jpg": 99,
	"./p7.jpg": 6909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;